<!-- AI识别 -->
<template>
    <div v-if="componentsData.type == 21">
        <div class="bg-div" :style="bgStyle">
            <div
                v-if="componentsData.content.title"
                :style="titleStyle"
                class="title-box"
            >
                {{ componentsData.content.title }}
            </div>
            <div class="image-box">
                <div class="image-div">
                    <Icon type="md-camera" class="mr12" size="22" color="#999"/>
                    <div>拍照上传</div>
                </div>
                <div class="image-div">
                    <Icon type="md-image" class="mr12" size="22" color="#999"/>
                    <div>从相册选择</div>
                </div>
            </div>
            <div class="image-tip">AI将根据照片自动识别以下字段</div>
            <div class="table-box">
                <table>
                    <tbody>
                        <tr
                            v-for="(e, i) in componentsData.content.table_list"
                            :key="i"
                            :style="txtStyle2"
                        >
                            <td
                                :style="{
                                    ...txtStyle1,
                                    ...borderStyle,
                                    ...titleStyle,
                                }"
                                class="w100"
                            >
                                {{ e.label }}
                            </td>
                            <td :style="borderStyle"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        borderStyle() {
            const content = this.componentsData.content;
            return {
                border: `1px solid ${content.border_color}`,
            };
        },
        txtStyle1() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.title_background_color,
            };
        },
        txtStyle2() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.fill_color,
            };
        },
        titleStyle() {
            const content = this.componentsData.content;
            return {
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.table-box table {
    width: 100%;
    border-collapse: collapse;
}
.table-box td {
    padding: 6px;
    color: #ccc;
}
.title-box {
    margin-bottom: 3px;
    font-size: 18px;
}
.w100 {
    width: 110px;
}
.image-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.image-div {
    padding: 0 6px;
    width: 48%;
    height: 40px;
    line-height: 40px;
    background-color: #F2F7FA;
    border-radius: 4px;
    color: #000;
    display: flex;
    align-items: center;
}
.image-tip {
    margin: 6px 0;
    font-size: 13px;
    color: #999;
}
</style>
